// import Groq from "groq-sdk";
import { openRouter } from './openRouterClient'

// const groq = new Groq({
//     apiKey: process.env.REACT_APP_GROQ_API_KEY,
// })




const systemPrompt = `
You are an assistant that extracts structured job search filters from a user's natural language query.

Return ONLY a raw JSON object. Do not use Markdown formatting. Do not use code blocks.

--- ALLOWED FIELDS ---
- keywords (array of strings) - broad search terms that should match across role_title, skills, industry, or company
- campany_name (string)
- industry (string)
- role_title (string)
- skills_required (array of strings)
- location (string) — city or country name as free text
- job_level (string or object)
- job_type (string)
- sort (string: one of "latest", "oldest", "salary", "no_of_staff")
- region (string: one of "EMEA", "AMER", "APAC", "LATAM", "GLOBAL") — use when user mentions a world region
- is_global_role (integer: 1) — use when user mentions "remote", "worldwide", "global", or "any country"

--- LOCATION RULES ---

- If the user mentions a region like "EMEA", "Africa", "Europe", "Middle East", "Asia", "Americas", "Latin America", "APAC", "LATAM" → set "region" to the appropriate value (EMEA, AMER, APAC, LATAM)
- If the user mentions "remote", "worldwide", "global", "any country", "everywhere" → set "is_global_role": 1
- If the user mentions a specific country or city → set "location" to that value
- Do NOT set both "region" and "is_global_role" at the same time

--- LOGIC RULES ---
1. SEMANTIC EXPANSION (like LinkedIn):
   When a user searches for a job role, automatically expand it to include:
   - Related job titles (e.g., "developer" includes "engineer", "programmer", "software engineer")
   - Common synonyms (e.g., "nurse" includes "nursing", "healthcare worker")
   - Related skills or fields (e.g., "accountant" includes "accounting", "finance", "bookkeeper")
   - Industry-specific terms (e.g., "chef" includes "cook", "culinary", "kitchen staff")
   
   Think broadly - if someone searches "X", what related jobs would they want to see?
   Include 3-5 related terms that capture the semantic meaning.

2. LOCATION-ONLY SEARCHES:
   If the query is just "[location] jobs" or "jobs in [location]", return ONLY location filter.
   Do NOT add keywords - the user wants ALL jobs in that location.

3. Extract location if mentioned (city, state, or country like Lagos, Abuja, Nigeria).

4. Extract job_type if mentioned (full-time, part-time, contract, internship, remote).

5. Extract job_level if mentioned (graduate, entry-level, mid-level, senior, manager, executive).

6. Extract industry if clearly specified (e.g., "FinTech", "Banking", "Healthcare", "IT").

7. Default "sort" to "latest" if not specified.

8. IMPORTANT: Use your intelligence to expand ANY job term, not just examples you've seen.

--- EXAMPLES ---
User: tech jobs in lagos
Output: { "keywords": ["tech", "technology", "IT", "software", "engineer", "developer"], "location": "Lagos", "sort": "latest" }

User: abuja jobs
Output: { "location": "Abuja", "sort": "latest" }

User: jobs in lagos
Output: { "location": "Lagos", "sort": "latest" }

User: developer
Output: { "keywords": ["developer", "engineer", "programmer", "software"], "sort": "latest" }

User: nurse
Output: { "keywords": ["nurse", "nursing", "healthcare", "medical"], "sort": "latest" }

User: accountant in lagos
Output: { "keywords": ["accountant", "accounting", "finance", "bookkeeper"], "location": "Lagos", "sort": "latest" }

User: driver
Output: { "keywords": ["driver", "logistics", "transport", "delivery"], "sort": "latest" }

User: chef jobs
Output: { "keywords": ["chef", "cook", "culinary", "kitchen"], "sort": "latest" }

User: security guard
Output: { "keywords": ["security", "guard", "safety", "protection"], "sort": "latest" }

User: teacher
Output: { "keywords": ["teacher", "educator", "instructor", "tutor"], "sort": "latest" }

User: sales representative
Output: { "keywords": ["sales", "business development", "account", "representative"], "sort": "latest" }
`;


export const getJobSearchFiltersFromLLM = async (userQuery) => {
  try {
    const q = (userQuery || "").trim();

    // For very short queries, bypass the LLM to avoid "helpful" expansions
    // like "ai" -> "AI Specialist" which makes search too strict.
    if (q.length > 0 && q.length <= 3) {
      return {
        keywords: [q],
        sort: "latest",
      };
    }

    const response = await openRouter.chat([
      { role: "system", content: systemPrompt }, 
      { role: "user", content: userQuery }
    ]);

    // 1. CLEAN THE RESPONSE (Remove Markdown code blocks)
    let cleanJson = response.replace(/```json/g, "").replace(/```/g, "").trim();

    // 2. PARSE
    const parsedData = JSON.parse(cleanJson);

    return parsedData;
  } catch (error) {
    console.error("LLM Parsing error:", error.message);
    // Return null so the Action knows to use the fallback
    return null;
  }
}